import Axios from 'axios'
import qs from 'qs'

const CURSO_TIPOS = {
	'pos': 'Pós-Graduação',
	'grad': 'Graduação',
	'grad-ead': 'Graduação - EAD',
	'ext': 'Extensão',
	'pos-graduacao': 'Pós-Graduação',
	'graduacao': 'Graduação',
	'extensao': 'Extensão',
	'ta': 'Graduação - Transferência e aproveitamento',
	'ensmed' : 'Curso Técnico'
}

const ESTADOS = {
	'AC': 'Acre',
	'AL': 'Alagoas',
	'AM': 'Amazonas',
	'AP': 'Amapá',
	'BA': 'Bahia',
	'CE': 'Ceará',
	'DF': 'Distrito Federal',
	'ES': 'Espírito Santo',
	'GO': 'Goiás',
	'MA': 'Maranhão',
	'MG': 'Minas Gerais',
	'MS': 'Mato Grosso do Sul',
	'MT': 'Mato Grosso',
	'PA': 'Pará',
	'PB': 'Paraíba',
	'PE': 'Pernambuco',
	'PI': 'Piauí',
	'PR': 'Paraná',
	'RJ': 'Rio de Janeiro',
	'RN': 'Rio Grande do Norte',
	'RO': 'Rondônia',
	'RR': 'Roraima',
	'RS': 'Rio Grande do Sul',
	'SC': 'Santa Catarina',
	'SE': 'Sergipe',
	'SP': 'São Paulo',
	'TO': 'Tocantins'
}

const SLUG_REFERENCES = {
	"ä": "a",
	"à": "a",
	"ö": "o",
	"ü": "u",
	"á": "a",
	"â": "a",
	"é": "e",
	"ê": "e",
	"ó": "o",
	"Ä": "A",
	"Ö": "O",
	"Ü": "U",
	"Á": "A",
	"Â": "A",
	"É": "E",
	"Ê": "E",
	"Ó": "O",
	"ç": "c",
	"Ç": "C",
	"ã": "a",
	"Ã": "A",
	"í": "i",
	"Í": "I",
	"Ú": "U",
	"ú": "u",
	"õ": "o",
	"Õ": "O",
	"ô": "o",
	"Ô": "O",
	"|": "",
	"²": "2",
	"-": " "
}

const SLUG_REGEX = /[öäüÖÄÜáâàéêóõÁÂÉÊÓçÇãÃíÍúÚ|²-]/g

class UtilsFael {
	constructor(options = {endpoint: '', app: null}) {
		const fael_google_maps_api = document.querySelector('meta[name="fael_google_maps_api"]')
		const social_facebook = document.querySelector('meta[name="social_facebook"]')
		const social_instagram = document.querySelector('meta[name="social_instagram"]')
		const social_linkedin = document.querySelector('meta[name="social_linkedin"]')
		const social_twitter = document.querySelector('meta[name="social_twitter"]')
		const fael_cidade_id = document.querySelector('meta[name="fael_cidade_id"]')

		this.__endpoint = `${options.endpoint}/`
		this.__curso_tipos = CURSO_TIPOS
		this.__estados = ESTADOS
		this.__concursos_ativos = {
			grad: null,
			pos: null
		}
		this.referrer = null
		this.app = null
		this.google_maps_api = fael_google_maps_api ? fael_google_maps_api.getAttribute('content') : ''
		this.redes = {
			facebook: social_facebook ? social_facebook.getAttribute('content') : '',
			instagram: social_instagram ? social_instagram.getAttribute('content') : '',
			twitter: social_twitter ? social_twitter.getAttribute('content') : '',
			linkedin: social_linkedin ? social_linkedin.getAttribute('content') : '',
		}
		this.cidade_id = fael_cidade_id ? fael_cidade_id.getAttribute('content') : ''

		if (options.endpoint) {
			// this.setConcursosAtivos()
			this.setReferrer()
		}
		let url = new URL(document.URL);
		if (url.searchParams.get('v6') !== null) {
			localStorage.setItem('v6', url.searchParams.get('v6'));
		}
		if (url.searchParams.get('v10') !== null) {
			localStorage.setItem('v10', url.searchParams.get('v10'));
		}
		if ('polo-sao-jose-dos-campos' === url.searchParams.get('utm_source'))
			localStorage.setItem('v8', 'LandingSaoJosedosCampos')
	}

	getTipoCurso(tipo, uppercase = false) {
		if (this.__curso_tipos[tipo.toLowerCase()])
			return uppercase ? this.__curso_tipos[tipo.toLowerCase()].toUpperCase() : this.__curso_tipos[tipo.toLowerCase()]
		return ''
	}

	getEstadoByUF(uf, uppercase = false) {
		if (ESTADOS[uf.toUpperCase()])
			return uppercase ? ESTADOS[uf.toUpperCase()].toUpperCase() : ESTADOS[uf.toUpperCase()]
		return ''
	}

	async getConcursoAtivo(tipo) {
		if (this.__concursos_ativos[tipo])
			return Promise.resolve(this.__concursos_ativos[tipo])
		return await Axios
		.get(`${this.__endpoint}webservice/concurso-ativo/${tipo}`)
		.then(response => {
			this.__concursos_ativos[tipo] = response.data
			return Promise.resolve(response.data)
		})
	}

	getParameterByName(name) {
		name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	scrollTo(target, offset = 0) {
		const element = document.querySelector(target)
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				left: 0,
				behavior: 'smooth'
			})
		}
	}

	setReferrer() {
		if (document.referrer) {
			const regex = /.\w+.com|.\w+.br|.*\w+.org/g;
			let results = regex.exec(document.referrer);

			if (results != null && results.length > 0) {
				var result = results[0].substr(1);
				if (localStorage.getItem("referrer") == null || localStorage.getItem("referrer") != result) {
					if (document.referrer.includes("google.com")) {
						if (document.URL.split('gclid=')[1] == undefined)
							localStorage.setItem("referrer", 'Google-Organico');
						else
							localStorage.setItem("referrer", 'Google-Adwords');
					} else if (!result.match(/edu.br/g)) {
						localStorage.setItem("referrer", result);
					}
				}
			}
		} else {
			localStorage.setItem("referrer", "SITE-FAEL");
		}

		if (this.getParameterByName('utm_source') !== '')
			localStorage.setItem('referrer', this.getParameterByName('utm_source'));

		if (this.getParameterByName('gclid') !== '')
			localStorage.setItem("gclid", this.getParameterByName('gclid'))

		this.referrer = localStorage.getItem('referrer')
	}

	async setConcursosAtivos() {
		await ['grad', 'pos'].forEach(async tipo => {
			await Axios
			.get(`${this.__endpoint}webservice/concurso-ativo/${tipo}`)
			.then(response => {
				this.__concursos_ativos[tipo] = response.data
				this.app.$emit(`load-concurso-${tipo}`, response.data)
			})
		})
	}

	slugify(valor, space = '-') {
		return valor
		.replace(SLUG_REGEX, match => SLUG_REFERENCES[match])
		.toLowerCase()
		.replace(/\s{2,}/g, ' ')
		.replace(/\s+/g, space);
	}

	install(Vue, options = {endpoint: '', app: null}) {
		options.app = Vue
		Vue.mixin({
			filters: {
				slugify: this.slugify,
				getEstadoByUF: this.getEstadoByUF
			},
			beforeCreate() {
				if (!this.$utils.app)
					this.$utils.app = this
			},
		})
		Vue.prototype.$utils = new UtilsFael(options)
	}

	getUrlInscricao(cursoId = false) {
		let url = this.getSalesForceUrl();
		let params = {}
		if (localStorage.getItem('v6') !== null)
			params.v6 = localStorage.getItem('v6')
		if (cursoId !== false)
			params.v7 = cursoId
		if (localStorage.getItem('v8') !== null)
			params.v8 = localStorage.getItem('v8')
		if (localStorage.getItem('v10') !== null)
			params.v10 = localStorage.getItem('v10')

		if (Object.keys(params).length > 0)
			return url + '?' + qs.stringify(params);
		return url
	}

	getSalesForceUrl(metaName = 'sales_force_url') {
		metaName = metaName || 'sales_force_url'
		const sales_force_url = document.querySelector(`meta[name="${metaName}"]`)
		return sales_force_url ? sales_force_url.getAttribute('content') : ''
	}

	showAfter(date) {
		const showAfter = new Date(date)
		if (showAfter.getTime() - new Date().getTime() >= 0)
			return false
		return true
	}

	showUntil(date) {
		const showUntil = new Date(date)
		if (showUntil.getTime() - new Date().getTime() <= 0)
			return false
		return true
	}
}

export default new UtilsFael();
